export enum Locale {
  EnglishUS = 'en-US',
  SpanishUS = 'es-US',
  PortugueseBR = 'pt-BR',
}
